import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateParentForm from "../../forms/CreateOrUpdateParentForm";

interface CreateParentModalProps {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  error: string | null;
}

const CreateParentModal: React.FC<CreateParentModalProps> = ({
  open,
  onClose,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Register New Parent/Guardian"
    width="md"
    loading={loading}
  >
    <CreateOrUpdateParentForm loading={loading} error={error} />
  </AppModal>
);

export default CreateParentModal;
